import React, { useState, cloneElement } from "react";
import {
  List,
  ExportButton,
  RefreshButton,
  TopToolbar,
  Datagrid,
  TextField,
  ReferenceInput,
  AutocompleteInput,
  ReferenceField,
  DateField,
  CreateButton,
  ShowButton,
  Filter,
  TextInput,
  BooleanField,
  SelectInput,
  GET_ONE,
  useRecordContext,
  useResourceContext,
  FileField,
  DateInput,
} from "react-admin";
import { Scrollbars } from "react-custom-scrollbars";
import Spinner from "../spinner";
import myDataProvider from "../myRestProvider";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useLocation } from "react-router-dom";

const DeliveryTicketsFilter = (props) => (
  <Filter {...props}>
    <TextInput source="dn_number" />
    <DateInput source="dn_created_on" />
    <TextInput source="dn_description" />
    <TextInput source="dn_company_address" />
    <TextInput source="dn_dispatcher_email" />
    <TextInput source="dn_transporter_name" />
    <TextInput source="dn_dispatcher_name" />
    <TextInput source="dn_transporter_email" />
    <TextInput source="dn_driver_name" />
    <TextInput source="dn_site_name" />
    <TextInput source="dn_site_address" />
    {/* <TextInput source="dn_delivery_note" /> */}
    <TextInput source="pod_company_name" />
    <TextInput source="pod_receivers_full_name" />
    <TextInput source="pod_designation" />
    <TextInput source="pod_received_quantity" />
    <TextInput source="pod_received_quantity_uom" />
    <SelectInput source="pod_complaints_or_comments" choices={[
                { id: true, name: 'True' },
                { id: false, name: 'False' },
            ]}
    />
    {/* <TextInput source="pod_complaints_or_comments" /> */}
    <TextInput source="pod_comment_description" />
    <TextInput source="dn_customer_id" />
    <TextInput source="dn_sdo_number" />
    {/* <TextInput source="dn_driver_delivery_note" /> */}

  </Filter>
);


const ListActions = (props) => {
  const location = useLocation();
  const resource = useResourceContext();

  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [customFilterUrl, setCustomFilterUrl] = useState(
    location.search
  );

  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    console.log("...", location.pathname, `${apiUrl}/${resource}_csv`);
    options.method = "GET";
    let _url = location.pathname.split("?");
    if (_url.length > 1 && _url[1] !== "") {
      console.log("params found");

      setCustomFilterUrl(_url[1], () => {
        fetch(`${apiUrl}/${resource}_csv?${customFilterUrl}`, options)
          .then((res) => {
            return res.json();
          })
          .then((jsonD) => {
            console.log("json= inside callback", jsonD.data);
            const msg = jsonD.data ? jsonD.data[0].message : "";
            Swal.fire({
              html: msg,
              icon: "success",
            });
            //   this.setState({ modalShow: true});
            //   this.setState({ modalMsg: msg});
          });
      });
    } else {
      setCustomFilterUrl(
        location.search
      );
      fetch(
        `${apiUrl}/${resource}_csv?${location.search}`,
        options
      )
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
        });
    }
  };

  const onClose = () => {
    setModalShow(false);
  };

  const {
    filterValues,
    total,
    maxResults,
    currentSort,
    exporter,
    permanentFilter,
    showFilter,
    displayedFilters,
    filters,
    basePath,
  } = props;
  const csvResource = resource + "_csv";

  return (
    <React.Fragment>
      <TopToolbar>
        {filters &&
          cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: "button",
          })}
        <RefreshButton />
        {/* <ExportButton
          onClick={(e) => this.callExport(e)}
          disabled={total === 0}
          resource={csvResource}
          sort={currentSort}
          filter={{ ...filterValues, ...permanentFilter }}
          exporter={this.exporterModal}
          maxResults={maxResults}
          /> */}
        {/* <CreateButton basePath={basePath} /> */}
        <div>
          <button
            className="export-button"
            onClick={(e) => callExport(e)}
            disabled={total === 0}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
          >
            {<GetAppIcon />}
            <span>export</span>
          </button>
        </div>
      </TopToolbar>
      {modalShow && (
        <Modal open={modalShow} onClose={onClose} center>
          <h3>{modalMsg}</h3>
        </Modal>
      )}
    </React.Fragment>
  );
};

const SignedFileUrl = () => {
  const record = useRecordContext();
    {
      if (record.signed_file_url =="" || record.signed_file_url == null) {
        return <>-</>
      } else {
        return(<a href={record.signed_file_url} target="_blank">Download Signed File</a>)
      }
    }
};

const DispatcherFileUrl = () => {
  const record = useRecordContext();
  {
    if (record.dispatcher_file_url =="" || record.dispatcher_file_url == null) {
      return <>-</>
    } else {
      return(<a href={record.dispatcher_file_url} target="_blank">Download Dispatcher File</a>)
    }
  }
};

const DriverFileUrl = () => {
  const record = useRecordContext();
  {
    if (record.driver_file_url =="" || record.driver_file_url == null) {
      return <>-</>
    } else {
      return(<a href={record.driver_file_url} target="_blank">Download Driver File</a>)
    }
  }
};

const postResendDelTicket = (props) => {
  let dataToSend = {
    dn_number: props?.dn_number,
  };

  console.log("duppppppppppppppppppp", dataToSend, props);

  const options = CommonHeaderOption();
  const apiUrl = RUN_TIME_API_ENDPOINT;
  options.method = "POST";
  options.body = JSON.stringify(dataToSend);
  fetch(`${apiUrl}/resend_delivery_tickets`, options)
    .then((res) => {
      return res.json();
    })
    .then((json) => {
      if (json) {
        console.log("json reply", json, props);
        // setTimeout(()=>{
        if (json.message == "ERROR") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Unable to process your request at this time. Please try again later.",
          }).then((result) => {
            window.location.reload();
            // navigate(`/discount_schemes/${json.id}/show`)
          });
        } else {
          Swal.fire({
            html: "Successful",
            icon: "success",
          }).then((result) => {
            window.location.reload();
            // navigate(`/discount_schemes/${json.id}/show`)
          });
        }
      }
    }).catch(error => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Unable to process your request at this time. Please try again later.",
      }).then((result) => {
        // window.location.reload();
        console.log('eroror', error);
        // navigate(`/discount_schemes/${json.id}/show`)
      });
  });
};

const ResendDeliveryTicketButton = () => {
  const record = useRecordContext();
  return (
    <div>
      <button
        className="ds-button"
        // onClick={()=>setModalDupShow(!modalDupShow)}
        onClick={() => {
          Swal.fire({
            text: "Are you sure you want to re-send this delivery?",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Yes",
            denyButtonText: "No",
          }).then((result) => {
            if (result.isConfirmed) {
              postResendDelTicket(record);
            } else if (result.isDenied) {
              Swal.fire("Changes are not saved", "", "info");
            }
          });
        }}
      >
        <span>Re-Send Delivery Ticket</span>
      </button>
    </div>
  );
};

const DeliveryTicketsList = (props) => {

  return (
    <React.Fragment>
      <Scrollbars class="scroll-container">
        <List
          // {...props}
          // exporter={props.exporter}
          sort={{ field: "created_at", order: "DESC" }}
          filters={<DeliveryTicketsFilter />}
          title={"Delivery Tickets"}
          hasCreate={false}
          // bulkActionButtons={false}
          resource="delivery_tickets"
          actions={<ListActions permissions={props} />}
        >
          <Datagrid bulkActionButtons={false} rowClick={false}>
            <ReferenceField
                      label="User name"
                      source="user_id"
                      reference="users"
                      link="show"
                      allowEmpty
                    >
                      <TextField source="first_name" />
            </ReferenceField>
            <TextField source="dn_number" />
            <DateField source="dn_created_on" />
            <TextField source="dn_description" />
            <TextField source="dn_company_address" />
            <TextField source="dn_dispatcher_email" />
            <TextField source="dn_transporter_name" />
            <TextField source="dn_dispatcher_name" />
            <TextField source="dn_transporter_email" />
            <TextField source="dn_driver_name" />
            <TextField source="dn_site_name" />
            <TextField source="dn_site_address" />
            <TextField source="pod_company_name" />
            <TextField source="pod_receivers_full_name" />
            <TextField source="pod_designation" />
            <TextField source="pod_received_quantity" />
            <TextField source="pod_received_quantity_uom" />
            <TextField source="pod_complaints_or_comments" />
            <TextField source="pod_comment_description" />
            <TextField source="dn_customer_id" />
            <TextField source="dn_sdo_number" />
            <SignedFileUrl />
            <DispatcherFileUrl />
            <DriverFileUrl />
            <ResendDeliveryTicketButton />
          </Datagrid>
        </List>
      </Scrollbars>
    </React.Fragment>
  );
};

export default DeliveryTicketsList;
